<template lang="html">
  <div class="social-network-share">
    <ShareNetwork
      :class="[
        'social-network-share-button',
        network.name
      ]"
      v-for="(network, index) in socialNetworks"
      @click.native="pushToDataLayer('Share modal', `Share to ${network.name}`)"
      :network="network.name"
      :key="index"
      :url="url"
      :title="title"
      hashtags="MasPocoVendo">
        <font-awesome-icon class="social-network-share-icon" :icon="network.icon" />
    </ShareNetwork>
  </div>
</template>

<script>
import store from '@/store'

export default {
  props: {
    then: Function,
    props: Object
  },

  data: () => ({
    socialNetworks: [
      { name: 'facebook', icon: ['fab', 'facebook-f'] },
      { name: 'twitter', icon: ['fab', 'twitter'] },
      { name: 'whatsapp', icon: ['fab', 'whatsapp'] },
      { name: 'messenger', icon: ['fab', 'facebook-messenger'] },
      { name: 'telegram', icon: ['fab', 'telegram-plane'] },
      { name: 'email', icon: ['fas', 'envelope'] }
    ]
  }),

  computed: {
    url () { return this.props.info.url },

    title () { return this.props.info.title },

    description () { return this.props.info.description }
  },

  methods: {
    handleClose () {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss">
@import '../../scss/colors';

.social-network-share {
  display: block;
  text-align: center;
  max-width: 90%;
  margin: auto;

  &-button {
    display: inline-block;
    height: 4rem;
    width: 4rem;
    margin: 0.25rem;
    border-radius: 4px;
    font-size: 3rem;
    line-height: 4.25rem;
    background-color: $primary;
  }

  .facebook {
    background-color: #4267B2 !important;
  }

  .twitter {
    background-color: #00ACEE !important;
  }

  .whatsapp {
    background-color: #25D366 !important;
  }

  .messenger {
    background-image: linear-gradient(to bottom left, #FF6F62, #933BFF, #0297FF);
  }

  .telegram {
    background-color: #0088CC !important;
  }

  &-icon {
    color: white !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/SocialNetworkShare.vue